import type { AuditOutcome } from '@/api/types';

const OUTCOME_PILL = new Map<string, { className: string; label: string }>([
  ['SUCCESS', { className: 'badge-success', label: 'Success' }],
  ['DENIED', { className: 'badge-warning', label: 'Denied' }],
  ['FAILED', { className: 'badge-danger', label: 'Failed' }],
] satisfies [AuditOutcome, unknown][]);

/** An outcome's pill; one the screen does not know reads as itself. */
export function outcomePill(outcome: string): { className: string; label: string } {
  return OUTCOME_PILL.get(outcome) ?? { className: 'badge-neutral', label: outcome };
}
